/**
 * Extension slug for the subscriptions module.
 */
export const SUBSCRIPTIONS_EXTENSION_SLUG = 'iconic-wds-subscriptions';